import { FIELD_PATHS } from '@funnels/constants';
import { EmploymentEntityIndex } from '@funnels/types';
import { validateNotFutureDate } from '@funnels/utils';

import { DatePickerInputField } from '../../Fields';

interface EmploymentStartDateProps extends EmploymentEntityIndex {
  isDisabled?: boolean;
  isOptional?: boolean;
}

export const EmploymentStartDate = (props: EmploymentStartDateProps) => {
  const { employmentIndex, ...rest } = props;

  return (
    <DatePickerInputField
      {...rest}
      name={FIELD_PATHS.EMPLOYMENT_START_DATE(employmentIndex)}
      label="Start date"
      validate={validateNotFutureDate('Please enter a start date prior to this month', props.isOptional)}
    />
  );
};
